import { render } from "./MenuItemNavigation.vue?vue&type=template&id=a6009542&scoped=true"
import script from "./MenuItemNavigation.vue?vue&type=script&lang=js"
export * from "./MenuItemNavigation.vue?vue&type=script&lang=js"

import "./MenuItemNavigation.vue?vue&type=style&index=0&id=a6009542&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6009542"]])

export default __exports__